export default __webpack_public_path__ + "static/media/UPLOAD_ICONA.7835c4fe.svg";